<template>
  <form @submit.prevent="submit()">

    <h4>{{ $t('accounts.bank.details') }}</h4>

    <v-layout row wrap>
      <v-flex xs6 v-for="input in inputs" :key="input.key">
        <component
          :is="input.component"
          :config="input"
          v-model="$data[input.key]">
        </component>
      </v-flex>
      <v-flex xs12>
        <component
          :is="addressInputs[0].component"
          :config="addressInputs[0]"
          v-model="$data[addressInputs[0].key]">
        </component>
      </v-flex>
      <v-flex xs6 v-for="i in [1, 2, 3, 4]" :key="i">
        <component
          :is="addressInputs[i].component"
          :config="addressInputs[i]"
          v-model="$data[addressInputs[i].key]">
        </component>
      </v-flex>
    </v-layout>

    <h4>{{ $t('accounts.bank.kyc') }}</h4>

    <p v-if="kyc && kyc.status">
      <strong>{{ $t('accounts.bank.kycStatus.' + kyc.status, kyc) }}</strong>
    </p>

    <file-input
      v-else
      v-model="kycFile"
      :config="{ path: 'kycs', label: $t('accounts.bank.labels.kyc') }"
      :required="true">
    </file-input>

    <h4>{{ $t('accounts.bank.bank') }}</h4>

    <template v-for="input in bankInputs">
      <component
        :key="input.key"
        :is="input.component"
        :config="input"
        v-model="bank[input.key]">
      </component>
    </template>

    <v-card-row actions>
      <v-btn
        type="submit"
        primary light ripple
        :loading="loading || bankLoading || initLoading">
        {{ $t('accounts.bank.save') }}
      </v-btn>
    </v-card-row>
  </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import currentExpert from '@/mixins/currentExpert'
  import { TextInput, CountryInput, FileInput } from '@/components/inputs'
  export default {
    components: {
      FileInput
    },
    mixins: [currentExpert],
    data () {
      const address = this.expert.address || {}
      return {
        error: {},
        initLoading: true,
        first_name: this.expert.first_name,
        last_name: this.expert.last_name,
        AddressLine1: address.AddressLine1,
        PostalCode: address.PostalCode,
        City: address.City,
        Region: address.Region,
        Country: address.Country,
        kycFile: null
      }
    },
    computed: {
      ...mapGetters({
        bank: 'skiliko/bank/bank',
        kyc: 'skiliko/bank/kyc',
        bankLoading: 'skiliko/bank/isLoading'
      }),
      inputs () {
        return [
          { key: 'first_name', component: TextInput },
          { key: 'last_name', component: TextInput }
        ]
          .map(input => ({
            ...input,
            label: this.$t(`accounts.bank.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      },
      addressInputs () {
        return [
          { key: 'AddressLine1', component: TextInput }, { key: 'PostalCode', component: TextInput },
          { key: 'City', component: TextInput }, { key: 'Region', component: TextInput },
          { key: 'Country', component: CountryInput }
        ]
          .map(input => ({
            ...input,
            required: true,
            label: this.$t(`accounts.bank.labels.${input.key}`),
            errors: (this.error[`address[${input.key}]`] || []).map(e => () => e)
          }))
      },
      bankInputs () {
        return [
          { key: 'iban', component: TextInput },
          { key: 'bic', component: TextInput }
        ]
          .map(input => ({
            ...input,
            label: this.$t(`accounts.bank.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      }
    },
    methods: {
      ...mapActions({
        fetchBank: 'skiliko/bank/fetchBank',
        fetchKyc: 'skiliko/bank/fetchKyc',
        saveBank: 'skiliko/bank/save'
      }),
      submit () {
        this.error = {}
        this.save({ data: {
          first_name: this.first_name,
          last_name: this.last_name,
          address: {
            AddressLine1: this.AddressLine1,
            PostalCode: this.PostalCode,
            City: this.City,
            Country: this.Country,
            Region: this.Region
          },
          kyc: this.kycFile
        } })
          .then(_ => this.saveBank({ data: {
            iban: this.bank.iban,
            bic: this.bank.bic
          } }))
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    },
    mounted () {
      Promise.all([
        this.fetchBank(),
        this.fetchKyc()
      ])
        .then(_ => (this.initLoading = false))
        .catch(_ => (this.initLoading = false))
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/Bank.vue